export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/damage.f4eb83a3.svg","height":69,"width":69,"blurWidth":0,"blurHeight":0};